<div class="mgo-body">
  <router-outlet></router-outlet>
</div>
<div *ngIf="isLoaded" class="spinner-overlay">
  <div class="spinner-container">
    <div class="spinner-background"></div>
    <img src="assets/images/spinner.gif" alt="spinner" />
  </div>
</div>
